// extracted by mini-css-extract-plugin
export default {"header":"index_header_PqZ2N clearfix","logo":"index_logo_gxik8"};